import { Eye, EyeOff } from "lucide-react"
import type { ComponentProps } from "react"
import { useState } from "react"
import FormInput from "./FormInput"

type Props = Omit<
  ComponentProps<typeof FormInput>,
  | "inputMode"
  | "textContentType"
  | "secureTextEntry"
  | "icon"
  | "onIconClick"
  | "autoComplete"
> & {
  readonly isNewPassword: boolean
}

export default function FormPasswordField({
  isNewPassword,
  required = true,
  ...props
}: Props) {
  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const EyeIcon = showPassword ? EyeOff : Eye

  return (
    <FormInput
      {...props}
      type={showPassword ? "text" : "password"}
      autoComplete={isNewPassword ? "new-password" : undefined}
      icon={
        <EyeIcon
          strokeWidth={2}
          className="size-5 cursor-pointer"
          onClick={handleClickShowPassword}
        />
      }
      required={required}
    />
  )
}
